/**
 * Check if a boolean value is true or undefined
 */
export const isTrueOrUndefinedFn = (value?: boolean) => value !== false
